import Request from '@/utils/request'

const HomeApi = {
  // 登录
  loginSubmit(data) {
    return Request('/login', 'post', data)
  },
  // 个人信息
  setPersonal(data) {
    return Request('/app/login/setPersonal', 'post', data)
  },
  // 资源位
  assetsList(data) {
    return Request('/app/show/list', 'post', data)
  },
  // 首页滚动公告栏
  getSystemBulletin(data) {
    return Request('/app/report/saleAmountList', 'get', data)
  },
  // 商品列表
  getGoodsList(data) {
    return Request('/app/goods/pageList', 'post', data)
  },
  // 查询商品详情
  getGoodsDetail(data) {
    return Request('/app/goods/detail', 'get', data)
  },
  // 获取区域列表
  getAreaList() {
    return Request('/app/area/list', 'get')
  },
  // 获取区域列表
  orderCheck(data) {
    return Request('/app/order/check', 'post', data)
  },
  // 个人信息
  getUserPersonalInfo() {
    return Request('/app/user/personalInfo', 'post')
  },
  // 订单创建
  orderCreate(data) {
    return Request('/app/order/create', 'post', data)
  },
  // 订单详情
  getOrderDetail(data) {
    return Request('/app/shopping/order/orderDetails', 'get', data)
  },
  // 未读消息数量
  getUnReadNum() {
    return Request('/app/message/unReadNum', 'get')
  },
  // 解析地址
  areaParse(data) {
    return Request('/app/area/parse', 'get', data)
  },
  // 微信授权
  wechatAuth(data) {
    return Request('/app/user/wechatAuth', 'post', data)
  },
}

export default HomeApi